import './index.scss';

type AcademicYearTitleProps = {
  academicYear: string;
};

const AcademicYearTitle = ({ academicYear }: AcademicYearTitleProps) => {
  return <h3 className="academicYearTitle">{`${academicYear} учебный год`}</h3>;
};

export default AcademicYearTitle;
